var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmlocalconfiavel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1299",
    "data-name": "Grupo 1299",
    transform: "translate(-811 -2217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_895",
    "data-name": "Caminho 895",
    d: "M20.5,0A20.5,20.5,0,1,1,0,20.5,20.5,20.5,0,0,1,20.5,0Z",
    transform: "translate(811 2217)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1298",
    "data-name": "Grupo 1298",
    transform: "translate(324.098 1867.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_922",
    "data-name": "Caminho 922",
    d: "M507.4,357.607a8.881,8.881,0,0,0-8.888,8.888c0,6.665,8.888,16.505,8.888,16.505s8.887-9.84,8.887-16.505A8.881,8.881,0,0,0,507.4,357.607Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_923",
    "data-name": "Caminho 923",
    d: "M510.079,375.242l6.229-6.286-1.335-1.345-4.894,4.941-1.975-1.994-1.335,1.345Z",
    transform: "translate(-4.135 -5.012)",
    fill: "#9e9e9e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmlocalconfiavel);
export default __webpack_public_path__ + "static/media/Em local confiavel.cf97967915e831ea86e39d136cb789eb.svg";
export { ForwardRef as ReactComponent };